import { api } from "@/modules/api";
import type { components } from "@/__openapi__/backend/schema";

// Re-export generated types for convenience
export type NoteSuggestionInternalResponseSchema =
  components["schemas"]["NoteSuggestionInternalResponseSchema"];
export type NoteSuggestionSummaryInternalResponseSchema =
  components["schemas"]["NoteSuggestionSummaryInternalResponseSchema"];
export type SearchNoteSuggestionsInternalRequestSchema =
  components["schemas"]["SearchNoteSuggestionsInternalRequestSchema"];
export type SearchNoteSuggestionsInternalResponseSchema =
  components["schemas"]["SearchNoteSuggestionsInternalResponseSchema"];

export const fetchNoteSuggestionInternal = async (
  noteSuggestionId: string
): Promise<NoteSuggestionInternalResponseSchema | null> => {
  const response = await api.get("/internal/v1/note-suggestions/{note_suggestion_id}", {
    params: { path: { note_suggestion_id: noteSuggestionId } },
  });

  return response.data ?? null;
};

export const searchNoteSuggestionsInternal = async (
  params: SearchNoteSuggestionsInternalRequestSchema
): Promise<SearchNoteSuggestionsInternalResponseSchema | null> => {
  const response = await api.post("/internal/v1/note-suggestions/search", {
    body: params,
  });

  return response.data ?? null;
};
